// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";

import { Icons } from "@components";
import type { AbsenceMonitoringLevel } from "@modules/service/reducer/absence-monitoring/types";

type Props = $Exact<{
  level: AbsenceMonitoringLevel,
  index: number,
  onDisable: ?Function,
  onMoveUp: ?Function,
  onMoveDown: ?Function,
  onDelete: ?Function,
  readonly?: boolean,
  ...PropsFromLocalize,
}>;

export const MonitoringLevelHeader = (props: Props) => (
  <div className="monitoring-level-header__container">
    <div className="monitoring-level-header__split">
      <div className="monitoring-level-header__title">
        <h6>{props.t("ABSENCE_MONITORING_LEVEL_NO", { no: props.index })}</h6>
      </div>
      <div className="monitoring-level-header__label">
        <h6>
          {props.t("ABSENCE_MONITORING_LEVEL_EMPLOYESS_NO", {
            no: props.level.employeeCount,
          })}
        </h6>
      </div>
    </div>
    <div className="monitoring-level-header__split">
      {props.readonly ? null : (
        <React.Fragment>
          <div
            className={classNames("monitoring-level-header__disable", {
              enabled: props.onDisable,
            })}
            onClick={props.onDisable ? props.onDisable : undefined}
          >
            {props.level.isEnabled ? props.t("DISABLE") : props.t("ENABLE")}
          </div>
          <div className="monitoring-level-header__reorder">
            <div className="monitoring-level-header__reorder--up">
              <span
                className={`material-icons pointer text-color-${
                  props.onMoveUp ? "black" : "disabled"
                }`}
                onClick={props.onMoveUp ? props.onMoveUp : undefined}
              >
                arrow_back
              </span>
            </div>
            <div className="monitoring-level-header__reorder--down">
              <span
                className={`material-icons pointer text-color-${
                  props.onMoveDown ? "black" : "disabled"
                }`}
                onClick={props.onMoveDown ? props.onMoveDown : undefined}
              >
                arrow_back
              </span>
            </div>
          </div>
          <div className="monitoring-level-header__delete">
            <Icons.CloseIcon
              color={props.onDelete ? "charcoal-dark" : "disabled"}
              onClick={props.onDelete ? props.onDelete : undefined}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  </div>
);

export default localize()(MonitoringLevelHeader);
